import { SEARCH_META, SEARCH_TVSHOW } from "@/apollo/queries/search";
import SearchPageMetaTags from "@/components/MetaTags/SearchPageMetaTags";
import PseudoCanvas from "@/components/PseudoCanvas";
import SearchNoResults from "@/components/SearchNoResults";
import { useBreadcrumbs, useSearchConfigQuery } from "@/hooks";
import config, { getStoreId } from "@/lib/config";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import routes from "@/lib/routes";
import contentsStyles from "@/styles/Contents.module.scss";
import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var __N_SSP = true;
export default function Search(props) {
  var _router$query, _res$data, _searchConfig$livePal, _searchConfig$keyword, _hitWords$;
  const router = useRouter();
  const searchQuery = router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.q;
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  const res = useSearchConfigQuery({
    fetchPolicy: "cache-first"
  });
  const searchConfig = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.searchConfig;
  const isShowLivePalette = searchConfig === null || searchConfig === void 0 || (_searchConfig$livePal = searchConfig.livePaletteKeywords) === null || _searchConfig$livePal === void 0 ? void 0 : _searchConfig$livePal.includes(searchQuery);
  const hitWords = searchConfig === null || searchConfig === void 0 || (_searchConfig$keyword = searchConfig.keywordMinScore) === null || _searchConfig$keyword === void 0 ? void 0 : _searchConfig$keyword.filter(keywordWithScore => {
    const {
      keyword
    } = keywordWithScore;
    return keyword === searchQuery;
  });
  const minScoreValue = (hitWords === null || hitWords === void 0 ? void 0 : hitWords.length) > 0 ? (_hitWords$ = hitWords[0]) === null || _hitWords$ === void 0 ? void 0 : _hitWords$.score : searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.defaultMinScore;
  const minScore = minScoreValue;
  const schemas = useMemo(() => {
    const schemas = [{
      id: "search-channel",
      type: "palette",
      viewType: "slider",
      header: {
        text: "月額商品",
        link: {
          href: routes.search(searchQuery, "channel")
        }
      },
      graphql: {
        query: SEARCH_META,
        options: {
          variables: {
            keyword: searchQuery,
            filter: {
              not: {
                "values.channel": [getStoreId(), config.valuePlanId.vod]
              }
            },
            sort: "rel",
            offset: 0,
            limit: SLIDER_MAX_NUM,
            minScore
          }
        },
        path: "search"
      }
    }, {
      id: "search-store",
      type: "palette",
      viewType: "slider",
      header: {
        text: "単品商品",
        link: {
          href: routes.search(searchQuery, "store")
        }
      },
      graphql: {
        query: SEARCH_META,
        options: {
          variables: {
            keyword: searchQuery,
            filter: {
              "values.channel": getStoreId()
            },
            sort: "rel",
            offset: 0,
            limit: SLIDER_MAX_NUM,
            minScore
          }
        },
        path: "search"
      }
    }];
    schemas.unshift(isShowLivePalette && {
      id: "search-live",
      type: "palette",
      viewType: "slider",
      header: {
        text: "ライブ",
        link: {
          href: routes.search(searchQuery, "live")
        }
      },
      graphql: {
        query: SEARCH_META,
        options: {
          variables: {
            keyword: searchQuery,
            filter: {
              "values.is_live": true,
              time_range: {
                "values.encode_end_date": {
                  gte: "now"
                }
              }
            },
            sort: "rel",
            offset: 0,
            limit: SLIDER_MAX_NUM,
            minScore
          }
        },
        path: "search"
      }
    }, {
      id: "search-valueplan",
      type: "palette",
      viewType: "slider",
      header: {
        text: config.valuePlan.text,
        link: {
          href: routes.search(searchQuery, "valueplan")
        }
      },
      graphql: {
        query: SEARCH_TVSHOW,
        options: {
          variables: {
            keyword: searchQuery,
            filter: {
              "values.channel": config.valuePlanId.vod
            },
            sort: "rel",
            offset: 0,
            limit: SLIDER_MAX_NUM,
            minScore
          }
        },
        path: "search"
      }
    });
    return schemas;
  }, [searchQuery]);
  useEffect(() => {
    setBreadcrumbs([{
      text: "ホーム",
      href: routes.home
    }, {
      text: "検索結果"
    }]);
  }, [searchQuery]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SearchPageMetaTags, {
      keyword: searchQuery
    }), /*#__PURE__*/_jsxs("div", {
      className: contentsStyles.container,
      children: [searchQuery && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("header", {
          children: /*#__PURE__*/_jsxs("h1", {
            children: [searchQuery, "\u306E\u691C\u7D22\u7D50\u679C"]
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(PseudoCanvas, {
            schemas: schemas,
            noContent: /*#__PURE__*/_jsx(SearchNoResults, {
              searchQuery: searchQuery
            })
          })
        })]
      }), !searchQuery && /*#__PURE__*/_jsx(SearchNoResults, {
        searchQuery: searchQuery
      })]
    })]
  });
}